// components/DashboardContent.js
import React from "react";
import Home from "./Home";
import UserManagement from "./UserManagement";
import GeneratePayment from "./GeneratePayment";
import SignPayment from "./SignPayment";
import BoardTable from "./BoardTable";  // Newly added component

const DashboardContent = ({ selectedFeature }) => {
  switch (selectedFeature) {
    case "Home":
      return <Home />;
    case "User Management":
      return <UserManagement />;
    case "Trello Board Management":
      return <BoardTable />;
    case "Generate Payment":
      return <GeneratePayment />;
    case "Sign Payment":
      return <SignPayment />;
    default:
      return <Home />;
  }
};

export default DashboardContent;
